import React, { useEffect, useState } from "react";
import { useHistory, useNavigate } from "react-router-dom";
import { AiOutlineDown } from "react-icons/ai";
import { ChevronDown } from "lucide-react";
import axiosClient from "../../axios-client";

const ManagePlan = () => {
  const [selectedPlan, setSelectedPlan] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [subscriptions, setSubscriptions] = useState([]);
  const [plans, setPlans] = useState([]);
  const [planNames, setPlanNames] = useState([]);
  const navigate = useNavigate();

  const userID = localStorage.getItem("userID");
  const token = localStorage.getItem("token");

  // const plans = [
  //   { id: 1, name: "Basic Plan ($5.00/mth)" },
  //   { id: 2, name: "Standard Plan ($10.00/mth)" },
  //   { id: 3, name: "Premium Plan ($20.00/mth)" },
  // ];

  const handlePlanSelect = (planName) => {
    setSelectedPlan(planName);
    setIsOpen(false);
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toISOString().split("T")[0];
  };

  useEffect(() => {
    if (token) {
      const fetchSubscriptions = async () => {
        try {
          const response = await axiosClient.get(
            `/subscriptions/getSubscriptionsByUser/${userID}`
          );

          // console.log("Subscriptions:", response.data);
          // const reportDownload = response.data[0].plan.features.reportDownloads;
          if (
            response.data.length > 0 &&
            response.data[0].status === "Active"
          ) {
            setSubscriptions(response.data);
            console.log("Subscriptions:", subscriptions);
          }
        } catch (error) {
          console.error("Error fetching subscriptions:", error);
        }
      };
      fetchSubscriptions();
    }
  }, [token, userID]);

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const response = await axiosClient.get("/plans/getall");
        if (response.data.success) {
          const sortedPlans = response.data.plans.sort(
            (a, b) => a.price - b.price
          );
          // console.log("plansss", response.data.plans);
          setPlans(sortedPlans);
          const names = sortedPlans.map((plan) => plan.name);
          setPlanNames(names);
          // console.log("Plan names:", names);
        }
      } catch (error) {
        console.error("Error fetching plans:", error);
      }
    };

    fetchPlans();
  }, []);

  const handleUpdatePlan = () => {
    navigate("/pricing");
  };

  return (
    <div className="p-4 max-w-7xl mx-auto w-full">
      <h2 className="text-xl md:text-2xl font-semibold">Manage Plan</h2>
      <p className="font4 mb-2 text-sm md:text-base">
        View and update your current subscription plan.
      </p>
      <hr />
      <div className="mb-4 mt-4">
        <p className="font4 text-sm md:text-base">Current Plan</p>
        {subscriptions.length > 0 ? (
          <>
            <p className="font-semibold mb-2 text-sm md:text-base">
              {subscriptions[0].plan.name} Plan ${subscriptions[0].plan.price}
            </p>
            <p className="font4 text-sm md:text-base">Billing Cycle</p>
            <p className="font-semibold mb-2 text-sm md:text-base">
              {subscriptions[0].plan.billingCycle} (Next billing date:{" "}
              {formatDate(subscriptions[0].endDate)})
            </p>
          </>
        ) : (
          <p className="font-semibold mb-2 text-sm md:text-base">
            No active subscription found.
          </p>
        )}
      </div>

      <div className="mb-4">
        <label className="block font-medium mb-2 text-sm md:text-base">
          Change/Update Plan
        </label>
        <div className="relative">
          <div
            className="w-full sm:w-3/4 md:w-1/2 border border-black text-gray-700 py-2 px-4 rounded-md leading-tight focus:outline-none focus:bg-white focus:border-gray-500 cursor-pointer flex justify-between items-center"
            onClick={() => setIsOpen(!isOpen)}
          >
            <span className="text-sm md:text-base">
              {selectedPlan || "Select a plan"}
            </span>
            <ChevronDown
              className={`transform ${
                isOpen ? "rotate-180" : ""
              } transition-transform`}
            />
          </div>

          {isOpen && (
            <div className="absolute z-10 w-full sm:w-3/4 md:w-1/2 mt-1 bg-white border border-gray-300 rounded-md shadow-lg">
              {planNames.map((name, index) => (
                <div
                  key={index}
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm md:text-base"
                  onClick={() => handlePlanSelect(name)}
                >
                  {name}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <button
        onClick={() => setShowDetails(true)}
        className="text-[#34749B] hover:text-blue-600 underline mb-6 text-sm md:text-base"
      >
        {showDetails ? "Hide details" : "Show more details"}
      </button>

      {/* {showDetails && (
        <div className="text-gray-700 mb-4 text-sm md:text-base">
          <p>More details about the plans and billing cycle.</p>
        </div>
      )} */}
      {showDetails && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-white rounded-lg p-6 max-w-sm w-full text-center ">
            <div className="flex justify-end">
              <div
                onClick={() => setShowDetails(false)}
                className=" text-white rounded-lg cursor-pointer"
              >
                <img
                  src="images/close1.png"
                  alt="tick"
                  className="w-3 h-3 sm:w-5 sm:h-5"
                />
              </div>
            </div>
            <p className="text-lg font-semibold">
              (Thank you for upgrading! A payment link will be sent to your
              email shortly. Your account will be activated upon payment
              confirmation.)
            </p>
            <div className="flex justify-center space-x-4"></div>
          </div>
        </div>
      )}

      <button
        onClick={handleUpdatePlan}
        className="w-full sm:w-auto block px-6 md:px-10 hover:bg-black text-white p-2 rounded-md bg-login font-medium text-sm md:text-base"
      >
        Update Plan
      </button>
    </div>
  );
};

export default ManagePlan;
